import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "container flex-container" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "el-icon-data-analysis" }, null, -1)
const _hoisted_4 = { class: "refresh-players" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "question-title" }
const _hoisted_7 = {
  key: 1,
  class: "loading"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "el-icon-loading" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "el-icon-circle-check"
}
const _hoisted_10 = {
  key: 1,
  class: "el-icon-close"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "el-icon-d-arrow-left" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_progress = _resolveComponent("el-progress")
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")
  const _component_el_collapse = _resolveComponent("el-collapse")
  const _component_el_space = _resolveComponent("el-space")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_tabs = _resolveComponent("el-tabs")
  const _component_router_link = _resolveComponent("router-link")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, {
      class: "box-card",
      shadow: "hover"
    }, {
      header: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("h2", null, [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("game.title")) + " - " + _toDisplayString(_ctx.$route.params.code), 1)
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "mini",
              icon: "el-icon-refresh",
              loading: _ctx.loading,
              disabled: _ctx.loading,
              onClick: _ctx.refreshStats
            }, null, 8, ["loading", "disabled", "onClick"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_tabs, {
          modelValue: _ctx.currentPlayerTab,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentPlayerTab = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              name: "first",
              label: _ctx.$t('game.players.tabs.questions')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, {
                  class: "box-card",
                  shadow: "hover"
                }, {
                  header: _withCtx(() => [
                    _createVNode("div", _hoisted_5, [
                      _createVNode("div", null, [
                        _createVNode("h3", null, _toDisplayString(_ctx.$t("game.questions.title")), 1),
                        _createVNode("small", null, _toDisplayString(_ctx.$t("game.questions.description")), 1)
                      ])
                    ])
                  ]),
                  default: _withCtx(() => [
                    (!_ctx.loading || _ctx.getQuestionData)
                      ? (_openBlock(), _createBlock(_component_el_space, {
                          key: 0,
                          class: "full-width",
                          fill: "",
                          direction: "vertical",
                          spacer: _ctx.spacer
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_collapse, {
                              accordion: "",
                              class: "questions"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getQuestionData, (question, index) => {
                                  return (_openBlock(), _createBlock(_component_el_collapse_item, {
                                    key: index,
                                    name: index
                                  }, {
                                    title: _withCtx(() => [
                                      _createVNode(_component_el_progress, {
                                        type: "circle",
                                        "stroke-width": 6,
                                        width: 60,
                                        color: _ctx.customColors,
                                        percentage: 
                          Math.min(
                            Math.round((2 - question.average) * 100, 100),
                            100
                          )
                        
                                      }, null, 8, ["color", "percentage"]),
                                      _createVNode("div", _hoisted_6, _toDisplayString(question.title), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(question.options, (option, ind) => {
                                        return (_openBlock(), _createBlock("div", {
                                          key: ind,
                                          class: ind == question.correct ? 'opt-correct' : 'opt'
                                        }, _toDisplayString(option), 3))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["name"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["spacer"]))
                      : (_openBlock(), _createBlock("div", _hoisted_7, [
                          _hoisted_8
                        ]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('game.players.tabs.all'),
              name: "firstb"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_el_table, {
                  data: 
              _ctx.getPlayerData.filter(
                (data) =>
                  !_ctx.search ||
                  data.alias.toLowerCase().includes(_ctx.search.toLowerCase())
              )
            ,
                  style: {"width":"100%"},
                  "default-sort": { prop: 'totalAnswers', order: 'ascending' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, { type: "expand" }, {
                      default: _withCtx((props) => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(props.row.answers, (answer, index) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "player-answer",
                            key: index
                          }, [
                            _createTextVNode(_toDisplayString(index + 1) + ": ", 1),
                            (answer == 1)
                              ? (_openBlock(), _createBlock("i", _hoisted_9))
                              : _createCommentVNode("", true),
                            (answer > 1)
                              ? (_openBlock(), _createBlock("i", _hoisted_10))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      sortable: "",
                      prop: "alias",
                      label: _ctx.$t('game.players.table.headers.name')
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      sortable: "",
                      prop: "totalAnswers",
                      label: _ctx.$t('game.players.table.headers.answers')
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      sortable: "",
                      prop: "time",
                      label: _ctx.$t('game.players.table.headers.time'),
                      formatter: _ctx.formatSeconds
                    }, null, 8, ["label", "formatter"]),
                    _createVNode(_component_el_table_column, {
                      sortable: "",
                      prop: "puzzleDone",
                      label: _ctx.$t('game.players.table.headers.puzzle'),
                      formatter: _ctx.formatSeconds
                    }, null, 8, ["label", "formatter"])
                  ]),
                  _: 1
                }, 8, ["data"]), [
                  [_directive_loading, _ctx.loading || !_ctx.getPlayerData]
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode("div", null, [
      _hoisted_11,
      _createVNode(_component_router_link, { to: { name: 'Games' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("general.back")), 1)
        ]),
        _: 1
      })
    ])
  ]))
}